import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { DropdownMenu } from '@ff-os/shared-react/components/dropdown/partials/DropdownMenu';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { List } from '@ff-os/shared-react/components/list/List';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { useContextMenuState } from '@ff-os/shared-react/hooks/useContextMenuState';
import styles from './ContextMenuCollapsed.module.scss';

export const ContextMenuCollapsed = ({ replace, crop }: Props) => {

    const { t } = useTranslation();
    const element = useRef<HTMLDivElement>(null);
    const [isOpen, setOpen] = useContextMenuState(element);

    return (
        <div className={styles.container}>
            <IconButton small onClick={() => setOpen(true)} className={styles.toggle}>
                <Icon size='small' type='general-ui-ellipsis-v' />
            </IconButton>

            <div className={styles.dropdown} ref={element}>
                <DropdownMenu onClick={() => setOpen(false)} isOpen={isOpen} minHeight={100}>
                    <List>
                        <ListItem onClick={replace}>
                            <Icon type='general-ui-replace' className={styles.icon} />
                            {t('image_uploader.replace')}
                        </ListItem>
                        <ListItem onClick={crop}>
                            <Icon type='general-ui-crop' className={styles.icon} />
                            {t('image_uploader.edit')}
                        </ListItem>
                    </List>
                </DropdownMenu>
            </div>
        </div>
    );
};

type Props = {
    replace: () => void;
    crop: () => void;
};